const roles = {
  operator: "Operator",
  supervisor: "Supervisor",
  engineer: "Engineer",
  superAdmin: "Super Admin",
  admin: "Admin",
  reliability: "Reliability"
};
export default roles;
